import React, { useState, useEffect } from 'react';
import './invitepopup.scss';
import AccountBg from '../../assets/profile-bg.png';
import SSButton from '../SSButton';
import InputComponent from '../InputComponent';
import { toast } from 'react-toastify';
import { validateEmail } from '../../utils';
import { DOMAIN } from '../../Constants/base';
import { postReq } from '../../utils/api';
import { postLogger } from '../../utils/analytics';
import SSProductItem from '../SSProductItem';
import { trackEvents } from '../../utils/analytics';
import { getSessionStorage, setSessionStorage } from '../../utils';

export default function InvitePopUp(props) {
  const userToken = JSON.parse(localStorage.getItem('ss-auth-sales')) || {};
  const { setOpenInvitePopUp, availableTeamPlans, getTeamMembers } = props;
  const [userEmailInput, setUserEmailInput] = useState('');
  const [currentSelectedProducts, setCurrentSelectedProducts] = useState([]);
  const [isClickedOnce, setIsClickedOnce] = useState(false);
  const [allPlans, setAllPlans] = useState([...availableTeamPlans]);
  const [isDisabledBtn, setIsDisabledBtn] = useState(true);
  const [showLoader, setShowLoader] = useState(false);
  const profilesSession = getSessionStorage('current-profile');

  useEffect(() => {
    setAllPlans(availableTeamPlans);
  }, [availableTeamPlans]);

  useEffect(() => {
    if (currentSelectedProducts.length === 0) {
      setIsClickedOnce(false);
      setIsDisabledBtn(true);
    } else if (userEmailInput) {
      setIsDisabledBtn(false);
    }
  }, [currentSelectedProducts]);

  useEffect(() => {
    if (isClickedOnce) {
      let updatingAllTeamPlans = allPlans.map((item) => {
        if (currentSelectedProducts.some((prod) => prod.id === item.id)) {
          return {
            ...item,
            isDisabled: false,
          };
        } else {
          return {
            ...item,
            isDisabled: true,
          };
        }
      });
      setAllPlans(updatingAllTeamPlans);
    } else {
      let updatingAllTeamPlans = [...allPlans];
      updatingAllTeamPlans.forEach((item) => delete item['isDisabled']);
      setAllPlans(updatingAllTeamPlans);
    }
  }, [isClickedOnce]);

  const isToolActivated = (plan) => {
    return currentSelectedProducts.some((prod) => prod.id === plan);
  };

  const handleItemClicked = (prodClicked) => {
    setIsClickedOnce(true);
    let isAlreadyClicked = currentSelectedProducts.some((prod) => prod.id === prodClicked.id);
    if (isAlreadyClicked) {
      let filtredArray = currentSelectedProducts.filter((prod) => prod.id !== prodClicked.id);
      setCurrentSelectedProducts(filtredArray);
    } else setCurrentSelectedProducts([...currentSelectedProducts, prodClicked]);
  };

  const sendInvites = async () => {
    if (currentSelectedProducts.length === 0) {
      toast.error('Please select a bundle to continue', {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      return;
    }
    const emails = userEmailInput.split(',');
    let isAllEmailsValid = true;
    let validEmails = [];
    emails.forEach((email) => {
      email = email.trim();
      if (!validateEmail(email)) isAllEmailsValid = false;
      else validEmails.push(email);
    });
    if (!isAllEmailsValid) {
      toast.error('Please enter valid email address', {
        position: 'top-center',
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      });
      return;
    } else {
      let url = `${DOMAIN}/v1/user/v2/invite-team`;
      validEmails = [validEmails[0]];
      if (validEmails[0].length === 0) {
        toast.error('Please enter valid email address to continue', {
          position: 'top-center',
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        return;
      }

      let payloadEmails = [];
      validEmails.forEach((validEm) =>
        payloadEmails.push({
          email: validEm,
        })
      );
      if (showLoader) return;
      setShowLoader(true);
      let payload = {
        invitees: payloadEmails,
        productId: currentSelectedProducts[0]['id'],
      };

      let requestHeaders = {
        authorization: `bearer ${userToken?.accessToken ? userToken?.accessToken : userToken}`,
      };

      let itemObj = {
        item_id: currentSelectedProducts[0]['id'],
        item_name: currentSelectedProducts[0]['nickName'],
        price: currentSelectedProducts[0]['price'],
        quantity: 1,
      };

      const sendEmailResp = await postReq({ url, requestHeaders, payload });
      const { code, data } = sendEmailResp;
      let timeoutCode = code.toString();
      timeoutCode = Array.from(timeoutCode)[0];
      if (code) {
        setShowLoader(false);
      }
      if (code === 200) {
        trackEvents('purchase', {
          userId: profilesSession.userId,
          items: itemObj,
          currency: currentSelectedProducts[0]['currency'],
          value: currentSelectedProducts[0]['price'],
        });

        trackEvents('invite_team_member', {
          userId: profilesSession.userId,
          product_id: currentSelectedProducts[0]['id'],
          product_name: currentSelectedProducts[0]['nickName'],
        });

        toast.success(data?.message ? data?.message : 'Invites sent!', {
          position: 'top-center',
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
        setOpenInvitePopUp(false);
        if (data.showCheckoutScreen) {
          setSessionStorage({
            key: 'product-info',
            value: {
              userId: profilesSession.userId,
              items: itemObj,
              currency: currentSelectedProducts[0]['currency'],
              value: currentSelectedProducts[0]['price'],
            },
          });
          window.location.replace(data.url);
        } else {
          //GTM event
          window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
          window.dataLayer.push({
            event: 'purchase',
            user_id: profilesSession.userId,
            type: 'team_member',
            ecommerce: {
              currency: currentSelectedProducts[0]['currency'],
              value: currentSelectedProducts[0]['price'],
              items: [
                {
                  item_id: currentSelectedProducts[0]['id'],
                  item_name: currentSelectedProducts[0]['nickName'],
                  price: currentSelectedProducts[0]['price'],
                  discount: 0.0,
                  quantity: 1,
                },
              ],
            },
          });

          getTeamMembers();
        }
      }
      if (code === 201) {
        setOpenInvitePopUp(false);
        toast.error(data.message, {
          position: 'top-center',
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: false,
          progress: undefined,
        });
      }
      if (timeoutCode === '5') {
        let newPayload = {
          ...payload,
          code,
        };
        postLogger('SEND_INVITES', newPayload);
      }
    }
  };

  return (
    <div className="invite-popup">
      <div className="footer">
        <SSButton
          btnText={'back'}
          onClickHandle={() => {
            setOpenInvitePopUp(false);
          }}
        ></SSButton>
        <SSButton
          btnText={'invite'}
          showLoader={showLoader}
          type={'filled'}
          onClickHandle={() => {
            sendInvites();
          }}
          isDisabled={isDisabledBtn}
        ></SSButton>
      </div>
      <div className="header">
        <h1>Invite Team Members</h1>
        {/* <p>
          Audience Engager helps you post domain expert articles, insightful posts and viral stories on all your social
          platforms.
        </p> */}
      </div>
      <div className="email-inputs">
        <div className="lable">TEAM MEMBER EMAIL</div>
        <div className="input-container">
          <InputComponent
            inputStyle="email-input"
            type="text"
            placeholder={'abc@gmail.com'}
            value={userEmailInput}
            onChange={(e) => {
              setUserEmailInput(e.target.value);
              if (e.target.value.length > 0 && currentSelectedProducts.length > 0) setIsDisabledBtn(false);
              else setIsDisabledBtn(true);
            }}
            handleEnter={() => {
              sendInvites();
            }}
          ></InputComponent>
        </div>
        {/* <div className="email-note">
          To invite more team members at once you can add multiple emails sepparated by a comma like so:
          julian@holofy.io, eduard@holofy.io, etc.
        </div> */}
        <div className="seat-selection">
          <div className="title">SUBSCRIBE MEMBERS TO</div>
          <div className="tools">
            {allPlans?.length &&
              allPlans.map((plan) => {
                return (
                  <SSProductItem
                    key={plan.id}
                    isClicked={isToolActivated(plan.id)}
                    handleItemClicked={handleItemClicked}
                    product={plan}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
